module.exports = __webpack_public_path__ + "img/landingpage-bg4.a0b9fb9c.png";